'use client';
import React, { useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { BASE_FILE_URL, BASE_URL, BG_COLORS, COLORS } from '@/common/constants';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { DownloadOutlined, LeftOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import { getWebsiteCodeHeader } from '@/common/pageConfig';
import { twMerge } from 'tailwind-merge';

const BangVanBan = (props) => {
  const { postss, angencies, textTypes, websiteCode, menuActive } = props;
  const t = useTranslations('');
  const router = useRouter();
  const totalPages = get(postss, 'totalPages', 0);
  const page = get(postss, 'page', 1);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const angency = searchParams.get('angency');
  const textType = searchParams.get('textType');
  const search = searchParams.get('search');
  const [downloading, setDownloading] = useState({}); // Track downloading state for each item
  // Hàm download file qua API
  const handleDownloadFile = async (postsId, fileName) => {
    if (!postsId) return;

    try {
      setDownloading((prev) => ({ ...prev, [postsId]: true }));

      const response = await fetch(`${BASE_URL}/postss/downloadFileDocuments/${postsId}`, {
        method: 'GET',
        headers: {
          websiteCode: getWebsiteCodeHeader(websiteCode),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Lấy blob từ response
      const blob = await response.blob();

      // Tạo URL tạm thời cho blob
      const url = window.URL.createObjectURL(blob);

      // Tạo thẻ a ẩn để trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || `document_${postsId}.pdf`; // Tên file mặc định
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch {
    } finally {
      setDownloading((prev) => ({ ...prev, [postsId]: false }));
    }
  };

  const handleSubmitUpViewDocument = async (id) => {
    try {
      await fetch(`${BASE_URL}/postss/updateViews/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
    } catch {
      // alert(`Có lỗi xảy ra! ${error}`);
    }
  };

  const handleSearch = (search) => {
    const newParams = new URLSearchParams(searchParams);
    if (!search) {
      newParams.delete('search');
    } else {
      newParams.set('search', search);
    }
    newParams.set('page', 1);
    router.push(`${pathname}?${newParams.toString()}`);
  };
  const handleChangeTextType = (textType) => {
    const newParams = new URLSearchParams(searchParams);
    if (!textType) {
      newParams.delete('textType');
    } else {
      newParams.set('textType', textType);
    }
    newParams.set('page', 1);
    router.push(`${pathname}?${newParams.toString()}`);
  };
  const handleChangeAngency = (angency) => {
    const newParams = new URLSearchParams(searchParams);
    if (!angency) {
      newParams.delete('angency');
    } else {
      newParams.set('angency', angency);
    }
    newParams.set('page', 1);
    router.push(`${pathname}?${newParams.toString()}`);
  };
  const handleChangePage = (page) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page);
    router.push(`${pathname}?${newParams.toString()}`);
  };

  const gotoDetail = (document) => {
    router.push(`/van-ban/${document.slug}`);
  };
  return (
    <>
      <div className="flex items-center">
        <button className={twMerge('mb-2 min-w-8 rounded mr-2 aspect-square', BG_COLORS.greenLight)} onClick={() => router.back()}>
          <LeftOutlined className="!text-white" />
        </button>
        <h1 className={twMerge('text-2xl font-bold text-[#064A17] mb-2', COLORS.primary)}>{menuActive?.name ?? ''}</h1>
      </div>

      {/* <h1 className="text-2xl font-bold text-red-700 mb-3 uppercase">ĐƠN THƯ </h1> */}
      <div className="flex flex-wrap gap-4 mb-4">
        {/* Input tìm kiếm */}
        <input
          type="text"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleSearch(event.target.value);
            }
          }}
          defaultValue={search ?? ''}
          placeholder={t('pdfList.search')}
          className="flex-1 min-w-[200px] px-4 py-2 border border-[#ccc] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {/* Select Cơ quan ban hành */}
        <select
          value={angency}
          onChange={(e) => handleChangeAngency(e.target.value)}
          className="min-w-[200px] px-4 py-2 border rounded-md focus:outline-none 
                  border-[#ccc] focus:ring-2 focus:ring-blue-500">
          <option value="">{t('pdfList.selectAgency')}</option>
          {(angencies || []).map((agency) => (
            <option key={agency.id} value={agency.id}>
              {agency.name}
            </option>
          ))}
        </select>

        {/* Select Loại văn bản */}
        <select
          value={textType}
          onChange={(e) => handleChangeTextType(e.target.value)}
          className="min-w-[200px] px-4 py-2 border rounded-md focus:outline-none 
                  border-[#ccc] focus:ring-2 focus:ring-blue-500">
          <option value="">{t('pdfList.selectDocType')}</option>
          {(textTypes || []).map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead className="bg-gray-100">
            <tr>
              <th scope="col" className="px-4 py-3 w-2/12 font-semibold text-gray-700 text-sm  tracking-wider text-left">
                {t('pdfList.symbolNumber')}
              </th>
              <th scope="col" className="px-4 py-3  w-2/12 font-semibold text-gray-700 text-sm  tracking-wider text-center">
                {t('pdfList.issuedDate')}
              </th>

              <th scope="col" className="px-4 py-3 font-semibold text-gray-700 text-sm  tracking-wider text-left">
                {t('pdfList.summary')}
              </th>
              <th scope="col" className="w-[100px] px-4 py-3 font-semibold text-gray-700 text-sm  tracking-wider text-right">
                {t('pdfList.download')}
              </th>
            </tr>
          </thead>
          <tbody>
            {get(postss, 'results', [])?.length > 0 ? (
              postss.results.map((item) => (
                <tr key={item.id} className="bg-white border-b border-gray-200 hover:bg-gray-50">
                  <td
                    className="px-4 py-3 text-sm text-gray-600 cursor-pointer"
                    onClick={() => {
                      gotoDetail(item);
                      handleSubmitUpViewDocument(item?.id);
                    }}>
                    {item?.title}
                  </td>
                  <td
                    className="px-4 py-3 whitespace-nowrap text-center text-sm text-gray-600 cursor-pointer"
                    onClick={() => {
                      gotoDetail(item);
                      handleSubmitUpViewDocument(item?.id);
                    }}>
                    {new Date(item?.issuanceDate).toLocaleDateString('vi-VN') ?? ''}
                  </td>
                  <td
                    className="px-4 pt-3 text-sm text-gray-600 line-clamp-4 cursor-pointer"
                    onClick={() => {
                      gotoDetail(item);
                      handleSubmitUpViewDocument(item?.id);
                    }}>
                    <div
                      className="text-md content-articles ck ck-content ck-editor__editable 
                              ck-rounded-corners ck-editor__editable_inline ck-blurred line-clamp-4 overflow-y-hidden"
                      dangerouslySetInnerHTML={{ __html: item?.content ?? '' }}
                    />
                  </td>
                  <td className="px-4 py-3 text-sm text-center text-gray-600">
                    {item?.fileDocuments?.length > 1 ? (
                      <button
                        onClick={(e) => {
                          e.stopPropagation(); // Ngăn trigger click row
                          handleDownloadFile(item?.id, item?.title);
                        }}
                        disabled={downloading[item?.id] || isEmpty(item?.fileDocuments)}
                        className={`${
                          downloading[item?.id]
                            ? 'opacity-50 cursor-not-allowed'
                            : isEmpty(item?.fileDocuments)
                            ? 'opacity-30 cursor-not-allowed'
                            : 'hover:text-blue-600 cursor-pointer'
                        }`}
                        title={isEmpty(item?.fileDocuments) ? 'Không có file để tải' : downloading[item?.id] ? 'Đang tải...' : 'Tải xuống'}>
                        <DownloadOutlined />
                      </button>
                    ) : (
                      <a download href={!isEmpty(item?.fileDocuments?.[0]) ? `${BASE_FILE_URL}/${item?.fileDocuments?.[0]}` : undefined}>
                        <DownloadOutlined />
                      </a>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="border p-4 text-center">
                  {t('home.checkTable')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="mt-6 mb-2 flex gap-4 justify-end">
        <button
          onClick={() => handleChangePage(Math.max(page - 1, 1))}
          disabled={page === 1}
          className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 ">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path
              d="M12.2108 16.3332C11.9167 16.3331 11.6347 16.2103 11.4268 15.9918L6.99129 11.3308C6.78341 11.1123 
              6.66663 10.816 6.66663 10.507C6.66663 10.198 6.78341 9.90169 6.99129 9.68318L11.4268 5.02224C11.5291 
              4.91094 11.6515 4.82217 11.7867 4.76111C11.922 4.70004 12.0675 4.66789 12.2148 4.66655C12.362 4.6652 
              12.508 4.69469 12.6443 4.75327C12.7806 4.81186 12.9044 4.89839 13.0085 5.00779C13.1126 5.1172 13.195 
              5.2473 13.2507 5.3905C13.3065 5.53371 13.3345 5.68714 13.3333 5.84186C13.332 5.99658 13.3014 6.14948 
              13.2433 6.29165C13.1852 6.43381 13.1007 6.56239 12.9948 6.66988L9.34322 10.507L12.9948 14.3441C13.1498
               14.5071 13.2554 14.7147 13.2981 14.9407C13.3409 15.1667 13.3189 15.4009 13.235 15.6138C13.1511 15.8267 
               13.009 16.0087 12.8267 16.1367C12.6444 16.2648 12.4301 16.3331 12.2108 16.3332Z"
              fill="#fff"
            />
          </svg>
        </button>
        <div className="flex flex-wrap gap-2 justify-center items-center">
          {totalPages <= 10 ? (
            Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => handleChangePage(i + 1)}
                className={`px-3 py-1 rounded 
                  border ${page === i + 1 ? 'bg-blue-500 text-white font-semibold' : 'bg-white text-gray-800 border-gray-300'} hover:bg-blue-100`}>
                {i + 1}
              </button>
            ))
          ) : (
            <>
              <button
                onClick={() => handleChangePage(1)}
                className={`px-3 py-1 rounded
                         border ${page === 1 ? 'bg-blue-500 text-white font-semibold' : 'bg-white text-gray-800 border-gray-300'} hover:bg-blue-100`}>
                1
              </button>

              {page > 4 && <span className="px-2">...</span>}

              {Array.from({ length: 5 }, (_, i) => {
                const pageNum = page - 2 + i;
                if (pageNum > 1 && pageNum < totalPages) {
                  return (
                    <button
                      key={pageNum}
                      onClick={() => handleChangePage(pageNum)}
                      className={`px-3 py-1 rounded
                         border ${
                           page === pageNum ? 'bg-blue-500 text-white font-semibold' : 'bg-white text-gray-800 border-gray-300'
                         } hover:bg-blue-100`}>
                      {pageNum}
                    </button>
                  );
                }
                return null;
              })}

              {page < totalPages - 3 && <span className="px-2">...</span>}

              <button
                onClick={() => handleChangePage(totalPages)}
                className={`px-3 py-1 rounded 
                  border ${
                    page === totalPages ? 'bg-blue-500 text-white font-semibold' : 'bg-white text-gray-800 border-gray-300'
                  } hover:bg-blue-100`}>
                {totalPages}
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => handleChangePage(Math.min(page + 1, totalPages))}
          disabled={page === totalPages}
          className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path
              d="M7.78913 16.3332C7.56985 16.3331 7.35551 16.2648 7.1732 16.1367C6.99089 16.0087 
                6.84879 15.8267 6.76488 15.6138C6.68098 15.4009 6.65902 15.1667 6.70178 14.9407C6.74455 
                14.7147 6.85012 14.5071 7.00515 14.3441L10.6567 10.507L7.00515 6.66988C6.89925 6.56239 
                6.81477 6.43381 6.75665 6.29165C6.69854 6.14948 6.66795 5.99658 6.66667 5.84186C6.66539 
                5.68714 6.69345 5.53371 6.7492 5.3905C6.80496 5.2473 6.88729 5.1172 6.99141 5.00779C7.09553 
                4.89839 7.21933 4.81186 7.35561 4.75327C7.49189 4.69469 7.6379 4.6652 7.78514 4.66655C7.93238 
                4.66789 8.07788 4.70004 8.21317 4.76111C8.34846 4.82217 8.47082 4.91094 8.57311 5.02224L13.0086 
                9.68318C13.2165 9.90169 13.3333 10.198 13.3333 10.507C13.3333 10.816 13.2165 11.1123 13.0086 
                11.3308L8.57311 15.9918C8.3652 16.2103 8.0832 16.3331 7.78913 16.3332Z"
              fill="#fff"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default BangVanBan;
